<template>
    <h2>Analytics</h2>
</template>

<script>
export default {
    name: 'AnalyticsView'
}
</script>